"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregateRoot = exports.isAggregateRoot = void 0;
const Entity_1 = require("./Entity");
const DomainEvents_1 = require("./events/DomainEvents");
const debuggers_1 = require("../utils/debuggers");
const classDbg = debuggers_1.extendDebug(debuggers_1.getExtendedBaseDebug("AggregateRoot"));
/*
 * Static value for each concrete ref:
 *
 * */
exports.isAggregateRoot = (v) => {
    return v && typeof v === "object" && v instanceof AggregateRoot;
};
class AggregateRoot extends Entity_1.Entity {
    constructor(props, ref, id) {
        super(props, ref, id);
        this._domainEvents = [];
    }
    get domainEvents() {
        return this._domainEvents;
    }
    addDomainEvent(domainEvent) {
        // Add the domain taskEndReasonManagerAbbr to this aggregate's list of domain events
        this._domainEvents.push(domainEvent);
        // Add this aggregate instance to the domain taskEndReasonManagerAbbr's list of aggregates who's
        // events it eventually needs to dispatch.
        DomainEvents_1.DomainEvents.markAggregateForDispatch(this);
        // Log the domain taskEndReasonManagerAbbr
        this.logDomainEventAdded(domainEvent);
    }
    clearEvents() {
        this._domainEvents.splice(0, this._domainEvents.length);
    }
    logDomainEventAdded(domainEvent) {
        const thisClass = Reflect.getPrototypeOf(this);
        const domainEventClass = Reflect.getPrototypeOf(domainEvent);
        console.info(`[Domain Event Created]:`, thisClass.constructor.name, "==>", domainEventClass.constructor.name);
    }
    static handleValidationError(e, ref, id) {
        const dbg = classDbg("handleValidationError");
        dbg.vrbs("ref: %s/%s %o", ref, id, e);
    }
}
exports.AggregateRoot = AggregateRoot;
//# sourceMappingURL=AggregateRoot.js.map